import * as React from "react"
import {Box} from "@mui/material";

import { ArrowPercentage } from "@components";


export default function visibilityColumn() {
	return {
		name: 'visibility', label: 'Visibility',
		options: {
			filter: false,
			customBodyRowRender: (value, rowData) => <Box sx={{ textAlign: 'center' }}>
				<ArrowPercentage value={value} prev={rowData.visibilityPrev} useBackground />
			</Box>
		}
	}
}